import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import usePermissionDataStore from "../../Zustand/Store/usePermissionDataStore";
import { hasPermission } from "../../utils/permissionUtils";

const Layout4 = ({
  loading,
  heading,
  Route,
  btnName,
  add_action,
  extraButtons = [],
  children,
  showAddButton = true,
  subtitle,
  onAddBtClick,
  addButtonDisabled = false,
  addButtonLoading = false,
}) => {
  const navigate = useNavigate();
  const { Permission, isPermissionLoaded } = usePermissionDataStore();

  const hasAddPermission = useMemo(() => {
    if (!add_action) return true;
    return hasPermission(Permission, add_action, isPermissionLoaded);
  }, [add_action, Permission, isPermissionLoaded]);

  return (
    <>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <>
          <div className="ems-page-head">
            <div>
              <h1 className="ems-page-title">{heading}</h1>
              {subtitle && (
                <div className="ems-page-sub">
                  <span>{subtitle}</span>
                </div>
              )}
            </div>
            <div className="ems-head-actions">
              {showAddButton && btnName && hasAddPermission && Route && (
                <button
                  className="ems-btn ems-primary"
                  disabled={addButtonDisabled || addButtonLoading}
                  onClick={() => {
                    if (typeof onAddBtClick === "function") {
                      onAddBtClick();
                      return;
                    }
                    navigate(`${Route}/add`);
                  }}
                >
                  {addButtonLoading ? (
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      style={{
                        animation: "spin 0.8s linear infinite",
                        flexShrink: 0,
                      }}
                    >
                      <circle
                        cx="7.5"
                        cy="7.5"
                        r="5.5"
                        stroke="currentColor"
                        strokeOpacity=".3"
                        strokeWidth="2.5"
                        fill="none"
                      />
                      <path
                        d="M7.5 2A5.5 5.5 0 0 1 13 7.5"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        fill="none"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      style={{ flexShrink: 0 }}
                    >
                      <line x1="7.5" y1="1.5" x2="7.5" y2="13.5" />
                      <line x1="1.5" y1="7.5" x2="13.5" y2="7.5" />
                    </svg>
                  )}
                  {btnName}
                </button>
              )}
              {Array.isArray(extraButtons) &&
                extraButtons.map((button) =>
                  button?.show ? (
                    <button
                      key={button.label}
                      type="button"
                      className={`ems-btn ${
                        button.variant === "contained"
                          ? "ems-primary"
                          : "ems-ghost"
                      }`}
                      onClick={button.onClick}
                      disabled={button.disabled}
                    >
                      {button.label}
                    </button>
                  ) : null
                )}
            </div>
          </div>
          <div className="ems-section-divider" />
        </>
      )}
      {children}
    </>
  );
};

export default Layout4;
